var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalItemIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.73077 1.67398L25.2308 1.67495M7.73077 9.75094L25.2308 9.75202M7.73077 17.8279L25.2308 17.8289M1.67308 1.67308H1.68654M1.67308 9.75H1.68654M1.67308 17.8269H1.68654M2.34615 1.67308C2.34615 2.0448 2.0448 2.34615 1.67308 2.34615C1.30135 2.34615 1 2.0448 1 1.67308C1 1.30135 1.30135 1 1.67308 1C2.0448 1 2.34615 1.30135 2.34615 1.67308ZM2.34615 9.75C2.34615 10.1217 2.0448 10.4231 1.67308 10.4231C1.30135 10.4231 1 10.1217 1 9.75C1 9.37833 1.30135 9.07692 1.67308 9.07692C2.0448 9.07692 2.34615 9.37833 2.34615 9.75ZM2.34615 17.8269C2.34615 18.1986 2.0448 18.5 1.67308 18.5C1.30135 18.5 1 18.1986 1 17.8269C1 17.4553 1.30135 17.1538 1.67308 17.1538C2.0448 17.1538 2.34615 17.4553 2.34615 17.8269Z",
    stroke: "#89B03C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalItemIcon);
export default __webpack_public_path__ + "static/media/totalItemIcon.5254d662ea2a0a7d9a15e1bec62344ac.svg";
export { ForwardRef as ReactComponent };